import { initSelect } from './selectsUI';
import {
	$win,
	$hero,
	$header,
	$wrapper,
	getCurrentDevice,
	manualUpdate,
	toggleManualUpdate
} from './utils';

function toggleScrolledState() {
	const $bm = $('.bm');
	let animationTimeout = null;

	if ( getCurrentDevice() == 'mobile') {
		$wrapper.css('padding-top', $header.height());

		return;
	}

	if ( $hero.length ) {
		const $headerClone = $header.clone(true);
		const $bmClone = $bm.clone(true);
		const $modalNav = $('.navigation-modal');
		const $navItems = $('.navigation > ul > li');

		$header.toggleClass('show-nav-trigger', $navItems.length > 6);

		changeIds($bmClone);
		changeIds($headerClone);
		syncFields($bm, $bmClone);

		$headerClone.addClass('scrolled');
		$bmClone.addClass('cloned d-none');

		$headerClone.insertAfter($header);
		$bmClone.insertAfter($('.hero__slider'));


		$win.on('load scroll', function() {
			const scrollTop = $win.scrollTop();
			const triggerPoint = $win.height() * .4;

			$modalNav.toggleClass('hide-elements', scrollTop <= triggerPoint);
			$headerClone.toggleClass('active', scrollTop > triggerPoint);
			$bmClone.toggleClass('inactive', scrollTop > triggerPoint);
		});

		// $win.on('load', function() {
			$bmClone.removeClass('d-none');
		// });
	} else {
		$header.addClass('scrolled active');

		adjustHeaderPadding($wrapper, $header);

		/* Add a small setTimeout because the height is slightly too big sometimes
		 - don't use load event because there are iframe that can be slow in footer */
		setTimeout(() => {
			adjustHeaderPadding($wrapper, $header);
		},50);

		/* Load event "just in case" the setTimeout causes an issue */
		$win.on('load', () => {
			adjustHeaderPadding($wrapper, $header);
		})
	}

	$bm.insertBefore('.header.scrolled .header__content__inner');
}

function adjustHeaderPadding($wrapper, $header) {
	$wrapper.css('padding-top', $header.height());
}

function changeIds($container) {
	$container.find('[id]').each(function() {
		const $this = $(this);
		const currentId = $this.attr('id');
		const newId = currentId + '-1';

		$container.find(`label[for="${currentId}"]`).attr('for', newId);
		$container.find(`[data-target="#${currentId}"]`).attr('data-target', '#' + newId);

		$this.attr('id', newId);
	});
}

function syncFields($firstContainer, $secondContainer) {
	// Update Inputs
	$firstContainer.find('input').on('change', function() {
		updateTwin($secondContainer, $(this).attr('name'), $(this).val());
	});

	$secondContainer.find('input').on('change', function() {
		updateTwin($firstContainer, $(this).attr('name'), $(this).val());
	});

	//Update Selects
	$firstContainer.find('select').on('change', function() {
		updateTwin($secondContainer, $(this).attr('name'), $(this).val(), true);
	});

	$secondContainer.find('select').on('change', function() {
		updateTwin($firstContainer, $(this).attr('name'), $(this).val(), true);
	});

	function updateTwin($container, name, val, isSelect = false) {
		const $field = $container.find(`[name="${name}"]`);

		if ( !manualUpdate ) {
			$field.val(val);

			if ( isSelect ) {
				initSelect($field);
			}

			if ( $field.hasClass('js-bm-start') || $field.hasClass('js-bm-end') || $field.hasClass('js-qty-field') ) {
				toggleManualUpdate()

				$field.trigger('change');

				setTimeout(() => {
					toggleManualUpdate();
				}, 50)
			}

			if ( $field.parents('.js-custom-field-holder').length ) {
				$field.parents('.js-custom-field-holder').toggleClass('is-active', val != '');
			}
		}
	}
}

export default function headerUI() {
	toggleScrolledState();
}
